import React, { useEffect, useState } from "react";
import Chart from "chart.js";
import * as api from "core-module/services/api";
import UpdateDeviceAlias from "./UpdateDeviceAlias";
import Popup from "reactjs-popup";
import Button from "common/components/CustomButtons/Button.jsx";

const TrafficByDeviceCard = (props) => {
  const [editAliasDialogOpen, setEditAliasDialogOpen] = useState(false);
  const [macAddressForEdit, setMacAddressForEdit] = useState("");
  const [aliasNameForEdit, setAliasNameForEdit] = useState("");
  const [popupInstructions, setPopupInstructions] = useState(props.tooltipOpen);
  const [upData, setUpdata] = useState(0);
  const [downData, setDownData] = useState(0);
  const chartRef = React.createRef();

  function openDialog() {
    setEditAliasDialogOpen(true);
  }

  function closeDialog() {
    setEditAliasDialogOpen(false);
  }

  function getUpDownSum(upData, downData) {
    var sum = upData.map(function (num, i) {
      return num + downData[i];
    });
    return sum;
  }

  function didDataUpdate() {
    if (upData.length != props.upData.length) {
      return true;
    }
    if (downData.length != props.downData.length) {
      return true;
    }
    for (var i = 0; i < upData.length; i++) {
      if (upData[i] != props.upData[i] || downData[i] != props.downData[i]) {
        return true;
      }
    }
    return false;
  }

  useEffect(() => {
    if (didDataUpdate()) {
      setDownData(props.downData);
      setUpdata(props.upData);
      document.getElementById("myChart").remove();
      document.getElementById("chartjs-tooltip").remove();
      var tooltipEl = document.createElement("div");
      tooltipEl.id = "chartjs-tooltip";
      document.getElementById("chartContainer").appendChild(tooltipEl);

      var myChart = document.createElement("canvas");
      myChart.id = "myChart";
      document.getElementById("chartContainer").appendChild(myChart);

      const context = myChart.getContext("2d");
      setupChart(context);
    }
  }, [props]);
  
    function setupChart(ctx) {
    var backgroundColor = ["#47B4EB", "#EB4763", "#8e5ea2","#3cba9f","#006699", "#E0C952", "#7AA329", "#D291BC", "#f57f17", "#D9D5C8"];

    var dataResponse = {
      labels: props.labels,
      datasets: [
        {
          backgroundColor: backgroundColor,
          data: getUpDownSum(props.upData, props.downData),
          borderColor: "#43464b",
          hoverBorderWidth: 6,
        },
        {
          backgroundColor: backgroundColor,
          data: props.upData,
          borderColor: "#43464b",
          hoverBorderWidth: 2,
          hidden: true,
        },
      ],
    };

    var elements = {
      center: {
        color: "white",
      },
    };

    var myChart = new Chart(ctx, {
      type: "doughnut",
      data: dataResponse,
      options: {
        cutoutPercentage: 60,
        elements: elements,
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 0.75,
        hover: {
          onHover: function (e, el) {
            const section = el[0];
            const currentStyle = e.currentTarget.style;
            currentStyle.cursor = section ? "pointer" : "normal";
          },
        },
        legend: {
          display: true,
          labels: {
            fontColor: "white",
          },
          onClick: function (e, legendItem) {
            var index = legendItem.index;
            setMacAddressForEdit(props.macAddresses[index]);
            setAliasNameForEdit(props.labels[index]);
            openDialog();
          },
        },
        animation: {
          animateRotate: false,
          animateScale: false,
        },
        tooltips: {
          // Disable the on-canvas tooltip
          enabled: false,

          custom: function (tooltipModel) {
            var tooltipEl = document.getElementById("chartjs-tooltip");
            tooltipEl.style.display = "inline-block";

            // Hide if no tooltip
            if (tooltipModel.opacity === 0) {
              tooltipEl.innerHTML = "<p>100%</p>";

              itemWidth = tooltipEl.offsetWidth;
              tooltipEl.style.opacity = 0;
              return;
            }

            function getBody(bodyItem) {
              return bodyItem.lines;
            }

            function getCenterString(bytes) {
              if (bytes < 1000000) {
                var bytes = bytes / 1000;
                return bytes.toFixed(2) + "KB";
              }
              if (bytes < 1000000000) {
                var bytes = bytes / 1000000;
                return bytes.toFixed(2) + "MB";
              }
              if (bytes < 1000000000000) {
                var bytes = bytes / 1000000000;
                return bytes.toFixed(2) + "GB";
              }
              if (bytes < 1000000000000) {
                var bytes = bytes / 1000000000000;
                return bytes.toFixed(2) + "TB";
              }
              return bytes.toFixed(2) + "B";
            }

            var itemWidth = 0;

            // Set Text
            if (tooltipModel.body) {
              var bodyLines = tooltipModel.body.map(getBody);
              var data = this._data;
              var upData = data.datasets[1].data;
              var downData = data.datasets[0].data;
              var innerHtml =
                "<p>" + '<strong style="color:#27aae1">&darr;</strong>';
              bodyLines.forEach(function (body, i) {
                var upBytes = 0;
                var downBytes = 0;
                var upBytes = upData[tooltipModel.dataPoints[0].index];
                var downBytes = downData[tooltipModel.dataPoints[0].index];

                var up = getCenterString(upBytes);
                var down = getCenterString(downBytes);
                innerHtml +=
                  down +
                  "<br><br>" +
                  '<strong style="color:#dd3449">&uarr;</strong>' +
                  up;
              });

              innerHtml += "</p>";

              tooltipEl.innerHTML = innerHtml;

              itemWidth = tooltipEl.offsetWidth;
            }

            if (itemWidth < 80) {
              itemWidth *= 2;
              itemWidth += 5;
            }
            tooltipEl.style.opacity = 1;
            tooltipEl.style.color = "#FFF";

            // // `this` will be the overall tooltip
            var positionX = this._chart.width / 2;
            var positionY = (this._chart.height - this._chart.chartArea.top) / 2;

            // // Display, position, and set styles for font
            var canvas = this._chart;
            tooltipEl.style.position = "absolute";
            tooltipEl.style.left = positionX - itemWidth / 2 + "px";
            tooltipEl.style.top = positionY + this._chart.chartArea.top +15 + "px";
            tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
            tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
            tooltipEl.style.fontSize = "30px";
          },
        },
      },
    });
  }

  const contentStyle = { zIndex: "1000", fontFamily: "Helvetica" };
  const overlayStyle = { zIndex: "100" };

  return (
    <>
      <UpdateDeviceAlias
        user={props.user}
        dialogOpen={editAliasDialogOpen}
        closeDialog={closeDialog}
        macAddress={macAddressForEdit}
        aliasName={aliasNameForEdit}
      />
      <div id="chartContainer">
        <Popup
          trigger={(open) => <span />}
          {...{ contentStyle, overlayStyle }}
          position="top center"
          closeOnDocumentClick
          defaultOpen={popupInstructions}
          open={popupInstructions}
        >
          <div>
          <span style={{ fontWeight: "bold" }}>
            This chart is interactive!{" "}
          </span>
          <br />
          <span>
            Select a device from the devices in the legend below to edit their name.
          </span>
          <Button
            color="primaryRed"
            aria-label="open drawer"
            onClick={() => {
              setPopupInstructions(false);
              try {
                window.localStorage.setItem("editnamesTooltip", true);
              } catch (e) {
                console.log(e.message);
              }
            }}
          >
            GOT IT
          </Button>
          </div>
        </Popup>
        <div id="chartjs-tooltip"></div>
        <canvas id="myChart" ref={chartRef}></canvas>
      </div>
    </>
  );
};

export default TrafficByDeviceCard;
